import {Button, CardBody, CardHeader, Col, Form, FormGroup, Input, Row,} from "reactstrap";
import {useEffect} from "react";
import moment from "moment";

const Profile = ({modalData}) => {
    // const { modalData } = props;

    useEffect(() => {
        console.log(modalData);
    }, []);
    return (
        <>
            <div
                style={{
                    backgroundColor: "white",
                    overflow: "hidden",
                    borderRadius: "15px",
                }}
                className="shadow "
            >
                <CardHeader>
                    <Row className="align-items-center ">
                        <Col xs="8">
                            <h3 className="mb-0 text-white">APPLICANT DETAILS</h3>
                        </Col>
                        <Col className="text-right" xs="4">
                            {/*<CsvDownloader*/}
                            {/*    className="btn btnColor custom-font "*/}
                            {/*    filename="Progress-leaderboard"*/}
                            {/*    // columns={}*/}
                            {/*    datas={[modalData]}*/}
                            {/*    text="Download CSV"/>*/}
                        </Col>
                    </Row>
                </CardHeader>
                <hr className="my-0"/>
                <CardBody style={{overflowY: "scroll", height: "80vh"}}>
                    <Form>
                        {/* Sub Form set */}
                        <div>
                            <h6 className="heading-small text-muted mb-4">
                                Personsal Information
                            </h6>
                            <div //className="pl-lg-1"
                            >
                                <Row>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                Full Name
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-username"
                                                placeholder="Full Name"
                                                type="text"
                                                disabled
                                                value={modalData.name}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-email"
                                            >
                                                Partner's Name
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-email"
                                                placeholder="Partner's Name"
                                                type="email"
                                                disabled
                                                value={modalData.partnerName}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-first-name"
                                            >
                                                Date of Birth
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-first-name"
                                                placeholder="Date of Birth"
                                                type="text"
                                                disabled
                                                value={moment
                                                    .unix(modalData?.dob?.seconds)
                                                    .format("MM/DD/YYYY")}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-last-name"
                                            >
                                                Email Address
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-last-name"
                                                placeholder="Email Address"
                                                type="text"
                                                disabled
                                                value={modalData.email}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                Mobile Number
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-username"
                                                placeholder="Mobile Number"
                                                type="text"
                                                disabled
                                                value={modalData.phone}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                Alternate Mobile Number
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-username"
                                                placeholder="Alternate Mobile Number"
                                                type="text"
                                                disabled
                                                value={modalData.altPhone}
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/*<Col lg="6">*/}
                                    {/*    <FormGroup>*/}
                                    {/*        <label*/}
                                    {/*            className="form-control-label "*/}
                                    {/*            htmlFor="input-username"*/}
                                    {/*        >*/}
                                    {/*            Current Address*/}
                                    {/*        </label>*/}
                                    {/*        <Input*/}
                                    {/*            className="form-control-alternative"*/}

                                    {/*            id="input-username"*/}
                                    {/*            placeholder="Username"*/}
                                    {/*            type="text"*/}
                                    {/*            disabled*/}
                                    {/*            value={modalData.currentAddress}*/}
                                    {/*        />*/}
                                    {/*    </FormGroup>*/}
                                    {/*</Col>*/}
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                Current City of Residence
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-username"
                                                placeholder="City"
                                                type="text"
                                                disabled
                                                value={modalData.city}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                Home Town
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-username"
                                                placeholder="Home Town"
                                                type="text"
                                                disabled
                                                value={modalData.homeTown}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                CNIC
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-username"
                                                placeholder="CNIC"
                                                type="text"
                                                disabled
                                                value={modalData.cnic}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                Gender
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-username"
                                                placeholder="Gender"
                                                type="text"
                                                disabled
                                                value={modalData.gender}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                Nationality
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-username"
                                                placeholder="Nationality"
                                                type="text"
                                                disabled
                                                value={modalData.nationality}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <hr className=""/>
                        {/* Sub Form set */}
                        <div>
                            <h6 className="heading-small text-muted mb-4 ">
                                Educational information
                            </h6>
                            <div className="pl-lg-1">
                                <Row>
                                    <Col lg="4">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                Latest Degree
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-username"
                                                placeholder="Latest Degree"
                                                type="text"
                                                disabled
                                                value={modalData.degree}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="4">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-email"
                                            >
                                                University Name
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-email"
                                                placeholder=" University Name"
                                                type="email"
                                                disabled
                                                value={modalData.institute}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="4">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-first-name"
                                            >
                                                CGPA
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-first-name"
                                                placeholder="CGPA"
                                                type="text"
                                                disabled
                                                value={modalData.cgpa}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="4">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-last-name"
                                            >
                                                Specialization
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-last-name"
                                                placeholder="Specialization"
                                                type="text"
                                                disabled
                                                value={modalData.specialization}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="4">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                Graduating Year
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-username"
                                                placeholder="Graduating Year"
                                                type="text"
                                                disabled
                                                value={modalData.graduationYear}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="4">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                Resume
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-username"
                                                placeholder="Username"
                                                type="text"
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="12">
                                        <FormGroup>
                                            <label className="form-control-label ">
                                                Other Degree
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                rows="4"
                                                type="textarea"
                                                disabled
                                                value={modalData.otherDegree}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <hr className="my-4"/>
                        Internship
                        <div>
                            <h6 className="heading-small text-muted mb-4 ">
                                Interships & Experience
                            </h6>
                            <div className="pl-lg-1">
                                <Row>
                                    <Col lg="12">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                Mention Details of any Internships (Company Name,
                                                Department and Year of Internship)
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                placeholder="A few words about you ..."
                                                rows="3"
                                                type="textarea"
                                                disabled
                                                value={modalData.internshipDetails}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="3">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-email"
                                            >
                                                Experience (years)
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-email"
                                                placeholder="jesse@example.com"
                                                type="email"
                                                disabled
                                                value={modalData.yearsOfExperience}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="3">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-first-name"
                                            >
                                                Company Name
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-first-name"
                                                placeholder="First name"
                                                type="text"
                                                disabled
                                                value={modalData.companyName}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="3">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-last-name"
                                            >
                                                Designation
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-last-name"
                                                placeholder="Last name"
                                                type="text"
                                                disabled
                                                value={modalData.designation}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="3">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                Department
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-username"
                                                placeholder="Username"
                                                type="text"
                                                disabled
                                                value={modalData.Department}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="12">
                                        <FormGroup>
                                            <label className="form-control-label ">
                                                In case you are currently working somewhere, please
                                                specify the total tenure that you have been with your
                                                current employer
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                placeholder="A few words about you ..."
                                                rows="4"
                                                type="textarea"
                                                disabled
                                                value={modalData.currentEmployer}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <hr className="my-4"/>
                        {/* Org questions*/}
                        <div>
                            <h6 className="heading-small text-muted mb-4 ">
                                Organization Related Questions
                            </h6>
                            <div className="pl-lg-1">
                                <Row>
                                    <Col lg="12">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                Do you have any relatives who work for or have business
                                                relations with our organization in any capacity? *
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                placeholder="A few words about you ..."
                                                rows="3"
                                                type="textarea"
                                                disabled
                                                value={modalData.relativesCount}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="12">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                If Yes, please specify the Name and Designation of your
                                                relative
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                placeholder="A few words about you ..."
                                                rows="3"
                                                type="textarea"
                                                disabled
                                                value={modalData.relativeDetails}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="12">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                If Yes, please specify your Relationship with him/ Her
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                placeholder="A few words about you ..."
                                                rows="3"
                                                type="textarea"
                                                disabled
                                                value={modalData.relationshipType}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="3">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-email"
                                            >
                                                Have you ever been interviewed by our organisation
                                                before?*
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-email"
                                                placeholder="jesse@example.com"
                                                type="email"
                                                disabled
                                                value={modalData.pastInterviews}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="12">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-first-name"
                                            >
                                                If Yes, please specify the position and year
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                placeholder="A few words about you ..."
                                                rows="3"
                                                type="textarea"
                                                disabled
                                                value={modalData.pastInterviewDetails}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <hr className="my-4"/>
                        {/* candidate specific */}
                        <div>
                            <Row>
                                <Col>
                                    <h6 className="heading-small text-muted mb-4 ">
                                        Candidate Specific
                                    </h6>
                                </Col>
                                <Col
                                    style={{
                                        display: "flex",
                                        justifyContent: "right",
                                        height: 28,
                                        cursor: "default",
                                    }}
                                >
                                    {modalData.drivingLicensePicture ? (
                                        <Button
                                            color="primary"
                                            href={modalData.filename}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                window.open(
                                                    `${modalData.drivingLicensePicture}`,
                                                    "_blank"
                                                );
                                            }}
                                            size="sm"
                                        >
                                            Download Driving License
                                        </Button>
                                    ) : (
                                        ""
                                    )}
                                </Col>
                            </Row>
                            <div className="pl-lg-1">
                                <Row>
                                    {/*<Col lg="12">*/}
                                    {/*    <Col className="float-right" lg="3"*/}
                                    {/*    >*/}
                                    {/*        <FormGroup*/}
                                    {/*            style={{float: "right"}}*/}
                                    {/*        >*/}
                                    {/*            <label*/}
                                    {/*                className="form-control-label "*/}
                                    {/*                htmlFor="input-email"*/}
                                    {/*            >*/}
                                    {/*                Driving License*/}

                                    {/*            </label>*/}

                                    {/*            <img*/}
                                    {/*                src={modalData.drivingLicensePicture ? modalData.drivingLicensePicture : require('../../assets/img/brand/logo.png')}*/}
                                    {/*                alt=""*/}
                                    {/*                style={{objectFit: 'contain', float: 'right'}}*/}
                                    {/*                width={230}*/}
                                    {/*                height={'auto'}*/}

                                    {/*            />*/}
                                    {/*        </FormGroup>*/}
                                    {/*    </Col>*/}
                                    {/*</Col>*/}

                                    <Col lg="3">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                Do you have a valid driving license
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-username"
                                                placeholder="Username"
                                                type="text"
                                                disabled
                                                value={modalData.drivingLicenseValidity}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="3">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-first-name"
                                            >
                                                Career Aspirations & Desired Goal
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-first-name"
                                                placeholder="First name"
                                                type="text"
                                                disabled
                                                value={modalData.talentProgram}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="3">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-last-name"
                                            >
                                                Your personality in 3 words
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-last-name"
                                                placeholder="Last name"
                                                type="text"
                                                disabled
                                                value={modalData.personality}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="3">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                Please mention how you learned about our Talent Program
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-username"
                                                placeholder="Username"
                                                type="text"
                                                disabled
                                                value={modalData.talentProgramSource}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="3">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                If Others, Please specify*
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-username"
                                                placeholder="Username"
                                                type="text"
                                                disabled
                                                value={modalData.talentProgramSourceOther}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="3">
                                        <FormGroup>
                                            <label
                                                className="form-control-label "
                                                htmlFor="input-username"
                                            >
                                                If Others, Please specify
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-username"
                                                placeholder="Username"
                                                type="text"
                                                value={modalData.howYouFoundUs}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <hr className="pb-0 mb-0 mt-2" style={{marginBottom: 0}}/>
                    </Form>
                </CardBody>
            </div>
            {/* </Container> */}
        </>
    );
};

export default Profile;
